import { Component, Input, OnInit, AfterViewInit, ViewChild, ContentChildren, Renderer2, ContentChild, ElementRef, OnDestroy, TemplateRef, Output, EventEmitter, NgZone, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

import { AnimationEvent } from '../animations/animations.interface';
export class DropdownToggleComponent {
public templateRef: TemplateRef<any>;
public toggleElement: ElementRef;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-dropdown-toggle',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
'toggleElement': [{ type: ContentChild, args: ['toggleElement', ] },],
};
}

function DropdownToggleComponent_tsickle_Closure_declarations() {
/** @type {?} */
DropdownToggleComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropdownToggleComponent.ctorParameters;
/** @type {?} */
DropdownToggleComponent.propDecorators;
/** @type {?} */
DropdownToggleComponent.prototype.templateRef;
/** @type {?} */
DropdownToggleComponent.prototype.toggleElement;
}

export class DropdownMenuComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-dropdown-menu',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function DropdownMenuComponent_tsickle_Closure_declarations() {
/** @type {?} */
DropdownMenuComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropdownMenuComponent.ctorParameters;
/** @type {?} */
DropdownMenuComponent.propDecorators;
/** @type {?} */
DropdownMenuComponent.prototype.templateRef;
}

export class DropdownComponent implements AfterViewInit, OnDestroy {
private documentClickListener: Function;
private toggleListener: Function;
public buttonStyleClass = 'btn dropdown-toggle';
public buttonBackgroudColor = 'default';
public contentStyleClass = 'dropdown-menu';
public isCollapsed = true;
public isWrapper = true;
public styleClass = 'dropdown';
public toggleElement: Element;
public toggleText: string;
public onCollapseStart = new EventEmitter();
public onCollapseDone = new EventEmitter();
public dropdownToggleComponent: DropdownToggleComponent;
public dropdownMenuComponent: DropdownMenuComponent;
private defaultToggleElement: ElementRef;
/**
 * \@method constructor
 * @param {?} changeDetectorRef
 * @param {?} elementRef
 * @param {?} ngZone
 * @param {?} renderer2
 */
constructor(
private changeDetectorRef: ChangeDetectorRef,
private elementRef: ElementRef,
private ngZone: NgZone,
private renderer2: Renderer2
  ) {}
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterViewInit() {
    let /** @type {?} */ toggleNativeElement = this.dropdownToggleComponent && this.dropdownToggleComponent.toggleElement ?
      this.dropdownToggleComponent.toggleElement.nativeElement : this.toggleElement ?
        this.toggleElement : this.defaultToggleElement ?
          this.defaultToggleElement.nativeElement : null;
    if(toggleNativeElement) {
      this.ngZone.runOutsideAngular(() => {
        this.toggleListener = this.renderer2.listen(toggleNativeElement, 'click', (event: Event) => {
          this.toggleDropdown(event);
          this.changeDetectorRef.detectChanges();
        });
      });
    }
  }
/**
 * \@method ngOnDestroy
 * @return {?}
 */
ngOnDestroy() {
    this.unBindDocumentClickListener();
    if(this.toggleListener) {
      this.toggleListener();
    }
  }
/**
 * [toggle description]
 * \@method toggle
 * @param {?} event
 * @return {?}
 */
public toggleDropdown(event: Event): void {
    event.preventDefault();
    this.isCollapsed = !this.isCollapsed;
    if(!this.isCollapsed) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout (() => {
          this.bindDocumentClickListener();
        });
      });
    } else {
      this.unBindDocumentClickListener();
    }
  }
/**
 * [collapseStart description]
 * \@method collapseStart
 * @param {?} event
 * @return {?}
 */
public collapseStart(event: AnimationEvent): void {
    this.onCollapseStart.emit(event);
  }
/**
 * [collapseDone description]
 * \@method collapseDone
 * @param {?} event
 * @return {?}
 */
public collapseDone(event: AnimationEvent): void {
    this.onCollapseStart.emit(event);
  }
/**
 * [bindDocumentClickListener description]
 * \@method bindDocumentClickListener
 * @return {?}
 */
private bindDocumentClickListener(): void {
    this.ngZone.runOutsideAngular(() => {
      this.documentClickListener = this.renderer2.listen('document', 'click', (event: Event) => {
        if(!this.isCollapsed) {
          this.isCollapsed = true;
          this.unBindDocumentClickListener();
          this.changeDetectorRef.detectChanges();
        }
      });
    });
  }
/**
 * [unBindDocumentClickListener description]
 * \@method unBindDocumentClickListener
 * @return {?}
 */
private unBindDocumentClickListener(): void {
    if(this.documentClickListener) {
      this.documentClickListener();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-dropdown, [mk-dropdown]',
  template: `
    <ng-template #innerTemplate>
      <ng-container *ngIf="this.dropdownToggleComponent && this.dropdownToggleComponent.toggleElement else noToggleElement" [ngTemplateOutlet]="dropdownToggleComponent.templateRef"></ng-container>
      <ng-template #noToggleElement>
        <button *ngIf="toggleText || dropdownToggleComponent" [mkColor]="buttonBackgroudColor" mkColorProperty="background-color" mkColorPrefix="btn" [ngClass]="buttonStyleClass" #toggleElement>
          {{toggleText}}
          <ng-container [ngTemplateOutlet]="dropdownToggleComponent?.templateRef"></ng-container>
        </button>
      </ng-template>
      <ul [ngClass]="contentStyleClass" [collapseAnimation]="isCollapsed" (collapseAnimation.start)="collapseStart($event)" (collapseAnimation.done)="collapseDone($event)">
        <ng-container *ngIf="dropdownMenuComponent else noDropdownMenuComponent" [ngTemplateOutlet]="dropdownMenuComponent.templateRef"></ng-container>
        <ng-template #noDropdownMenuComponent>
          <ng-content></ng-content>
        </ng-template>
      </ul>
    </ng-template>

    <div *ngIf="isWrapper else noWrapper" [ngClass]="styleClass">
      <ng-container *ngTemplateOutlet="innerTemplate"></ng-container>
    </div>

    <ng-template #noWrapper>
      <ng-container *ngTemplateOutlet="innerTemplate"></ng-container>
    </ng-template>
  `,
  styles: [`
    .dropdown-menu {
      display: block;
    }

    .dropdown-menu.collapsing:not(.un-collapse) {
      -webkit-transition-property: height, padding-top, padding-bottom;
      transition-property: height, padding-top, padding-bottom;
      padding-top: 0;
      padding-bottom: 0;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: ElementRef, },
{type: NgZone, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'buttonStyleClass': [{ type: Input },],
'buttonBackgroudColor': [{ type: Input },],
'contentStyleClass': [{ type: Input },],
'isCollapsed': [{ type: Input },],
'isWrapper': [{ type: Input },],
'styleClass': [{ type: Input },],
'toggleElement': [{ type: Input },],
'toggleText': [{ type: Input },],
'onCollapseStart': [{ type: Output },],
'onCollapseDone': [{ type: Output },],
'dropdownToggleComponent': [{ type: ContentChild, args: [DropdownToggleComponent, ] },],
'dropdownMenuComponent': [{ type: ContentChild, args: [DropdownMenuComponent, ] },],
'defaultToggleElement': [{ type: ViewChild, args: ['toggleElement', ] },],
};
}

function DropdownComponent_tsickle_Closure_declarations() {
/** @type {?} */
DropdownComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropdownComponent.ctorParameters;
/** @type {?} */
DropdownComponent.propDecorators;
/** @type {?} */
DropdownComponent.prototype.documentClickListener;
/** @type {?} */
DropdownComponent.prototype.toggleListener;
/** @type {?} */
DropdownComponent.prototype.buttonStyleClass;
/** @type {?} */
DropdownComponent.prototype.buttonBackgroudColor;
/** @type {?} */
DropdownComponent.prototype.contentStyleClass;
/** @type {?} */
DropdownComponent.prototype.isCollapsed;
/** @type {?} */
DropdownComponent.prototype.isWrapper;
/** @type {?} */
DropdownComponent.prototype.styleClass;
/** @type {?} */
DropdownComponent.prototype.toggleElement;
/** @type {?} */
DropdownComponent.prototype.toggleText;
/** @type {?} */
DropdownComponent.prototype.onCollapseStart;
/** @type {?} */
DropdownComponent.prototype.onCollapseDone;
/** @type {?} */
DropdownComponent.prototype.dropdownToggleComponent;
/** @type {?} */
DropdownComponent.prototype.dropdownMenuComponent;
/** @type {?} */
DropdownComponent.prototype.defaultToggleElement;
/** @type {?} */
DropdownComponent.prototype.changeDetectorRef;
/** @type {?} */
DropdownComponent.prototype.elementRef;
/** @type {?} */
DropdownComponent.prototype.ngZone;
/** @type {?} */
DropdownComponent.prototype.renderer2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
